/* eslint-disable import/prefer-default-export */
import { IResponseBase } from 'src/types/response-base';
import {
  ARCHIVED_SCENARIOS,
  DELETE_SCENARIOS,
  GET_LIST_OF_SHARED_USERS,
  GET_LIST_OF_UNSHARED_USERS,
  GET_TABLE_DATA_FOR_SCENARIO_MANAGER,
  MARK_FINALIZED_SCENARIOS,
  REMOVE_SCENARIO_SHARE,
  SHARE_SCENARIO,
  UNMARK_FINALIZED_SCENARIOS,
  UN_ARCHIVED_SCENARIOS
} from 'src/constants';
import { axios } from 'src/lib';
import { IUserDetails } from '../../common/types/user.model';
import { ITableData } from '../../pricing-simulator/types/generic-table.model';

export function getScenarioTableData(
  body: { filter_inputs: any[] },
  sourceId: number
) {
  return axios
    .post(`${GET_TABLE_DATA_FOR_SCENARIO_MANAGER}${sourceId}/`, body)
    .then<ITableData>((response) => response.data);
}

export function deleteScenarios(
  body: { scenarios: number[] },
  sourceId: number
) {
  return axios.post(`${DELETE_SCENARIOS}${sourceId}/`, body);
}

export function archivedScenarios(
  body: { scenarios: number[] },
  sourceId: number
) {
  return axios.post(`${ARCHIVED_SCENARIOS}${sourceId}/`, body);
}

export function unArchivedScenarios(
  body: { scenarios: number[] },
  sourceId: number
) {
  return axios.post(`${UN_ARCHIVED_SCENARIOS}${sourceId}/`, body);
}

export function finalizedScenarios(
  body: { scenarios: number[] },
  sourceId: number
) {
  return axios.post(`${MARK_FINALIZED_SCENARIOS}${sourceId}/`, body);
}

export function unMarkFinalizedScenarios(
  body: { scenarios: number[] },
  sourceId: number
) {
  return axios.post(`${UNMARK_FINALIZED_SCENARIOS}${sourceId}/`, body);
}

export function shareScenario(
  body: { users: number[] },
  sourceId: number,
  scenarioId: number
) {
  return axios.post(`${SHARE_SCENARIO}${sourceId}/${scenarioId}/`, body);
}

export function removeScenarioShareAccess(
  body: { user_id: number },
  sourceId: number,
  scenarioId: number
) {
  return axios.post(`${REMOVE_SCENARIO_SHARE}${sourceId}/${scenarioId}/`, body);
}

export function fetchListOfUnsharedWithUsers(
  sourceId: number,
  scenarioId: number
) {
  return axios
    .get<IResponseBase<IUserDetails[]>>(
      `${GET_LIST_OF_UNSHARED_USERS}${sourceId}/${scenarioId}/`
    )
    .then((response) => response.data.data);
}

export function fetchListOfSharedWithUsers(
  sourceId: number,
  scenarioId: number
) {
  return axios
    .get<IResponseBase<IUserDetails[]>>(
      `${GET_LIST_OF_SHARED_USERS}${sourceId}/${scenarioId}/`
    )
    .then((response) => response.data.data);
}
